import React, { useState } from 'react';
import './WtlCalculator.css'
import Axios from 'axios';
import { useAuth } from "../Context/AuthContext";

const StrengthMuscleBuildingCalculator = () => {
  const [weight, setWeight] = useState('');
  const [reps, setReps] = useState('');
  const [oneRepMax, setOneRepMax] = useState(null);
  const { appUser, setUser, isLogin, setLogin } = useAuth();
  
  const calculateOneRepMax = async () => {
    if (!weight || !reps) {
      alert('Please enter valid values for weight and reps.');
      return;
    }

    const calculatedOneRepMax = parseFloat(weight) * (1 + parseFloat(reps) / 30);

    setOneRepMax(calculatedOneRepMax.toFixed(2));
    try{
      const response=await Axios.post('https://fitness-junction-bots.onrender.com/api/saveftdata',{'userEmail':appUser.email,'toolName':'WeightFor8RepsOnly','toolValue':(parseFloat(calculatedOneRepMax.toFixed(2)) * 0.79).toFixed(2)});
      console.log(response);
    }catch(error){
      console.log(error);
    }
  };

  return (
    <div className="strength-muscle-building-calculator-container">
      <h2>Strength and Muscle Building Calculator</h2>

      <div className="input-container">
        <label htmlFor="weight">Weight Lifted (lbs):</label>
        <input
          type="number"
          id="weight"
          value={weight}
          onChange={(e) => setWeight(e.target.value)}
        />
      </div>

      <div className="input-container">
        <label htmlFor="reps">Number of Reps:</label>
        <input
          type="number"
          id="reps"
          value={reps}
          onChange={(e) => setReps(e.target.value)}
        />
      </div>

      <button className="calculate-btn" onClick={calculateOneRepMax}>
        Calculate Correct Lifting Weight
      </button>

      {oneRepMax !== null && (
        <div className="result">
          <p>Estimated One Rep Max: {oneRepMax} lbs</p>
          <p>Estimated Maximum Lifts:</p>
          <p>5 Reps: {(parseFloat(oneRepMax) * 0.87).toFixed(2)} lbs</p>
          <p>8 Reps: {(parseFloat(oneRepMax) * 0.79).toFixed(2)} lbs</p>
          <p>10 Reps: {(parseFloat(oneRepMax) * 0.75).toFixed(2)} lbs</p>
        </div>
      )}
    </div>
  );
};

export default StrengthMuscleBuildingCalculator;
